import { Link } from "react-router-dom";
import LoadingShort from "../../load/loadingShort";
import { useSelector } from "react-redux";
import IniciaisLetras from "../../utils/iniciaisLetras";

type cardServicesProps = {
    icone?: string;
    nomeService: string;
    link: string;
    count: number | null;
    load?: boolean;
    funcao?: string;
    disabled?: boolean;
    title?: string;
}

interface User {
    tipo: string;
    membro: string;
    title?: string;
    funcao?: string;
}

interface RootState {
    account: {
        user: User
    };
}

export default function CardServices({ icone, nomeService, link, count, load, funcao, title, disabled = false }: cardServicesProps) {
    const user = useSelector((state: RootState) => state.account.user);
    const isActive = funcao === user?.funcao;

    return (
        <Link
            to={disabled ? '#' : link}
            title={title}
            style={{
                borderColor: disabled ? '#d1d5db' : isActive ? '#85287e' : '#85287e',
            }}
            className={[
                'tw-relative tw-flex tw-flex-col tw-items-center',
                'tw-w-[155px] tw-min-w-[130px] tw-h-[195px]',
                'tw-border tw-border-solid tw-rounded-xl',
                'tw-no-underline tw-text-inherit tw-overflow-hidden',
                'tw-transition-all tw-duration-300 tw-select-none tw-shadow-sm',
                isActive ? 'tw-bg-[#85287e]/10' : '', //tw-bg-white
                disabled
                    ? 'tw-opacity-40 tw-pointer-events-none'
                    : 'tw-cursor-pointer hover:tw-bg-[#85287e]/10 hover:tw-shadow-md hover:tw--translate-y-1',
            ].join(' ')}
        >
            {/* Ícone */}
            <div className="tw-flex tw-items-center tw-justify-center tw-flex-1 tw-p-3">
                {icone ? (
                    <img
                        src={icone}
                        alt={nomeService}
                        className="tw-h-[72px] tw-w-auto tw-object-contain tw-transition-all tw-duration-500"
                    />
                ) : (
                    <span className="tw-text-2xl tw-font-bold tw-text-[#85287e]">
                        <IniciaisLetras frase={nomeService} />
                    </span>
                )}
            </div>

            {/* Nome do serviço */}
            <div className="tw-px-2 tw-text-center tw-pb-1">
                <p className="tw-text-[12px] tw-leading-snug tw-text-gray-700 tw-font-medium">
                    {nomeService}
                </p>
            </div>

            {/* Contador */}
            <div className="tw-w-full tw-text-center tw-py-2 tw-bg-[#85287e]/5 tw-border-t tw-border-[#85287e]/10">
                {load ? (
                    <LoadingShort text="" />
                ) : (
                    <span className="tw-text-lg tw-font-extrabold tw-text-[#85287e]">
                        {count ?? 0}
                    </span>
                )}
            </div>
        </Link>
    );
}
